import React from 'react'
import { Card, CardContent } from '@mui/material'
import logoMyleBlue from '../../../assets/logos/myle-blue.png'
import loginBg from '../../../assets/images/loginBackground.png'

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="login-page" style={{ background: `url(${loginBg}) no-repeat` }}>
    <Card className="login-form" square>
      <CardContent className="car-content">
        <div className="form-header">
          <img className="logo" src={logoMyleBlue} alt="logo" />
          <h1>Welcome Back!</h1>
          <h3>Sign in to continue</h3>
        </div>
        {children}
      </CardContent>
    </Card>
  </div>
)

export default Wrapper
